var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-secondary',{staticClass:"gc-page-connect-wearable-success",attrs:{"header":_vm.headerOptions}},[_c('page-container',{staticClass:"container"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }